import React, {useState} from "react"
import styles from "./RunSAPPopup.module.css"
import {BaseButton, BasePopup} from "components"
import {handleError, toastSuccess} from "helpers"
import {useMutation} from "hooks"
import {academicPlansService} from "services"
import CampusSelect from "components/CampusSelect"
import ProgramSelect from "components/ProgramSelect"
import {NewStudentStatusSelect} from "components/NewStudentStatusSelect"
import {FormLabel} from "components/Form"
import {Row, Col} from "antd"

type RunSAPPopupProps = {
    isVisible: boolean
    onClose: () => void
    departmentId: number
}

const RunSAPPopup: React.FC<RunSAPPopupProps> = ({isVisible, onClose, departmentId}) => {
    const [campuses, setCampuses] = useState<any[]>([])
    const [programs, setPrograms] = useState<any[]>([])
    const [studentStatuses, setStudentStatuses] = useState<any[]>([])

    const runSapMutation = useMutation(
        async (params: Parameters<typeof academicPlansService.runSapProcess>[0]) => {
            return await academicPlansService.runSapProcess(params)
        },
        {
            onSuccess: () => {
                toastSuccess("SAP process started successfully and will take a few moments to complete.")
                onClose()
            },
            onError: (error) => handleError(error)
        }
    )

    const handleRunSAP = () => {
        runSapMutation.mutate({
            campusIds: campuses.length > 0 ? campuses.map((item) => item.id) : undefined,
            programIds: programs.length > 0 ? programs.map((item) => item.id) : undefined,
            studentStatusIds: studentStatuses.length > 0 ? studentStatuses.map((item) => item.statusId) : undefined
        })
    }

    return (
        <BasePopup
            isShow={isVisible}
            onClose={onClose}
            leftIcon="FILE_TEXT"
            leftIconColor="#fff"
            dialogContentClassName={styles.popupContent}
            destroyOnClose
            keyboard={false}
            maskClosable={false}
            width="auto">
            <div className={styles.container}>
                <h2 className={styles.title}>Run SAP</h2>
                <p className={styles.description}>
                    This will run the SAP (Satisfactory Academic Progress) process. You can optionally filter by campus,
                    program, and student status.
                </p>

                <div className={styles.filters}>
                    <Row gutter={[24, 24]}>
                        <Col span={24}>
                            <FormLabel label="Campus" />
                            <CampusSelect
                                value={campuses}
                                onChange={(values) => setCampuses(values)}
                                isMulti
                                isClearable
                                placeholder="Select campuses"
                            />
                        </Col>
                        <Col span={24}>
                            <FormLabel label="Program" />
                            <ProgramSelect
                                value={programs}
                                onChange={(values) => setPrograms(values)}
                                isMulti
                                isClearable
                                placeholder="Select programs"
                            />
                        </Col>
                        <Col span={24}>
                            <FormLabel label="Student Status" />
                            <NewStudentStatusSelect
                                value={studentStatuses}
                                onChange={(values) => setStudentStatuses(values)}
                                isMulti
                                isClearable
                                placeholder="Select student statuses"
                            />
                        </Col>
                    </Row>
                </div>

                <div className={styles.actions}>
                    <BaseButton
                        title="Cancel"
                        onClick={onClose}
                        variant="secondary"
                        disabled={runSapMutation.isLoading}
                    />
                    <BaseButton title="Run SAP" onClick={handleRunSAP} loading={runSapMutation.isLoading} />
                </div>
            </div>
        </BasePopup>
    )
}

export default RunSAPPopup
